import { unitErrorCodeTypes } from 'activate-errors';
import { ExternalReference, SourceType } from 'graphql-query-contracts';

import { Item } from 'components/form/Dropdown/Dropdown';

export type UnitInputFields = {
  name: string;
  description: string;
  floors: Item<string>[];
  externalIdSource: Item<SourceType> | null;
  externalUnitId: string;
  externalSourceEntityType: string;
};

export type UpdateUnitProps = {
  propertyId: string;
  unitId: string;
  unit: UnitInputFields;
  existingExternalReferences?: ExternalReference[];
};

export type UnitInputFieldKey = keyof UnitInputFields;

type ServerErrorCodeToFieldMappingType = {
  [key: string]: UnitInputFieldKey;
};

export const ServerErrorCodeToFieldMapping: ServerErrorCodeToFieldMappingType =
  {
    [unitErrorCodeTypes.unitNameAlreadyExistsError.code]: 'name',
    [unitErrorCodeTypes.unitNameMinimumCharacterError.code]: 'name',
  };
